<template>
  <div>
    <v-btn @click.stop="setDialog(true)" class="ma-1" color="primary" small text data-cy="releaseNoteListDialog"
      >Release Notes: {{ releaseNoteList.length }}</v-btn
    >
    <v-dialog v-model="dialog" max-width="800" persistent>
      <v-card>
        <v-card-title class="headline font-weight-thin">
          <div>
            <strong data-cy="label">{{ label }}</strong>
          </div>
        </v-card-title>

        <v-card-title class="mt-n5">
          <div class="subtitle-1" data-cy="releaseNoteCountMessage">{{ releaseNoteList.length }} Release Note(s)</div>
        </v-card-title>
        <v-card-text>
          <release-note-list-dialog-table :releaseNoteList="releaseNoteList"></release-note-list-dialog-table>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn @click="setDialog(false)" class="mr-2" outlined>Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ReleaseNoteListDialogTable from "./ReleaseNoteListDialogTable.vue";

export default {
  components: {
    ReleaseNoteListDialogTable,
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    async setDialog(val) {
      this.dialog = val;
    },
  },
  props: {
    label: { required: true, type: String },
    releaseNoteList: { required: true, type: Array },
  },
};
</script>
